<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@stores/auth'
import { useGlobalStore } from '@stores/global'

import Button from '@components/forms/Button.vue'
import AccountMenu from '@components/global/AccountMenu.vue'

const auth = useAuthStore()
const global = useGlobalStore()
</script>

<template>
	<header class="fixed left-0 top-0 z-40 w-full bg-black">
		<div class="container">
			<div class="relative flex h-16 items-center justify-between py-5">
				<router-link :to="{ name: 'index' }" class="cursor-pointer">
					<img src="https://d21cpkouqu9xdo.cloudfront.net/images/logos/logitech-g.svg" alt="Logitech G Logo" class="relative h-8" />
				</router-link>
				<div class="flex items-center justify-end gap-2">
					<AccountMenu v-if="auth.isAuthed" />
					<template v-else>
						<button class="mt-1 text-nowrap px-2 py-3 font-brown text-sm font-semibold uppercase text-logi-blue-400 transition-colors duration-200 hover:text-logi-blue-500" @click="auth.register">Create Account</button>
						<Button class="primary solid medium" icon="fa-regular fa-user" @click="auth.login">Login</Button>
					</template>
				</div>
			</div>
		</div>
	</header>
</template>

<style scoped>
.router-link-active {
	@apply text-logi-blue-500;
}
</style>
